import React from 'react';
import { useTranslation } from 'react-i18next';
import { nsarchives } from "../../../../../i18n/namespaces";
import { ViewerControlTooltip } from "../../tooltip";
import { ViewerControlButton } from "../button";
import '@isyc-react/design/main';
export const ViewerControlButtonZoomIn = props => {
  const {
    disabled,
    zoomIn
  } = props;
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.zoomIn')
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    disabled: disabled,
    onClick: () => zoomIn()
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-plus"
  })));
};
export const ViewerControlButtonZoomOut = props => {
  const {
    disabled,
    zoomOut
  } = props;
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.zoomOut')
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    disabled: disabled,
    onClick: () => zoomOut()
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-minus"
  })));
};
export const ViewerControlButtonZoomRestore = props => {
  const {
    disabled,
    zoomRestore
  } = props;
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.zoomRestore')
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    disabled: disabled,
    onClick: () => zoomRestore()
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-image-filter-center-focus"
  })));
};